<template>
  <v-list class="ma-0 pa-0 checkbox-list" dense>
    <v-list-item-group class="ma-0" v-model="currentValue" multiple>
      <v-list-item
        v-for="item in options"
        class="checkbox-item pa-0 ma-0"
        v-ripple="false"
        :key="item.id"
        :value="item.id"
        :data-testid="item.testId"
        :data-tourid="item.tourId"
      >
        <template v-slot:default="{ active }">
          <v-list-item-action class="mr-2 my-0">
            <v-checkbox :input-value="active"></v-checkbox>
          </v-list-item-action>

          <v-list-item-content class="pa-0">
            <div class="checkbox-text ml-0">
              <span class="font-size-12 blue-grey--text text--darken-3">
                {{ item.text }}
              </span>
            </div>
          </v-list-item-content>
        </template>
      </v-list-item>
    </v-list-item-group>
  </v-list>
</template>

<script>
export default {
  name: 'CheckboxFilter',

  props: {
    options: { type: Array, default: () => [] },
    initialValue: { type: Array, default: () => [] },
  },

  data() {
    return {
      currentValue: this.initialValue,
    }
  },

  watch: {
    initialValue() {
      this.currentValue = this.initialValue
    },

    currentValue() {
      this.$emit('change', this.currentValue)
    },
  },
}
</script>

<style lang="scss" scoped>
.checkbox-list {
  .v-list-item--link:hover,
  .v-list-item--link::before {
    background-color: transparent !important;
  }
}

.checkbox-item {
  min-height: 28px;
}

.checkbox-text {
  line-height: 15px;
}
</style>
